import person from "@/api/person/person"
import designer from "@/api/view/designer"
import personal_center from "@/api/personal_center/personal_center"
import view from '@/api/view/view.js'
const api = {
  ...person,
  ...personal_center,
  ...view,
  ...designer
}
export default api;
